import { getThemeColor, MapSettings, ModelRow, ModelSearchResult, UrlUtil } from "@mcleod/core";
import { AutogenLayoutPartialShipmentPlanningAvailableOrdersMap } from "./autogen/AutogenLayoutPartialShipmentPlanningAvailableOrdersMap";
import { MapPin, Snackbar } from "@mcleod/components";
import { TrimbleMap } from "@mcleod/components/src/components/map/TrimbleMap";

const DELIVERED_STATUS_CODE = "D";

export class PartialShipmentPlanningAvailableOrdersMap extends AutogenLayoutPartialShipmentPlanningAvailableOrdersMap {
    public maxPins = 500;
    private _movementIds;
    public get movementIds() {
        return this._movementIds;
    }
    public set movementIds(value) {
        this._movementIds = value;
    }

    async onLoad() {
        if (MapSettings.get()?.always_show_maps === true || this.mapAvailOrders.map instanceof TrimbleMap )
            this.plotPins();
        this.mapAvailOrders.createMapCallback = async () =>  {
            await this.mapAvailOrders.ensureLoaded();
            this.plotPins()
        }
        this.addLayoutLoadListener(() => {
            this.mapAvailOrders.fitPins();
        });   
    }



    async plotPins() {
        let pinData: ModelSearchResult = null;
        const urlProp = UrlUtil.getPropsFromUrl(window.location.search)
        if (urlProp != null && urlProp.movement_ids != null) {
            pinData = await this.mainDataSource.search({ movement_id_list: urlProp.movement_ids });
        }
        let summaryPins = this.summarizePinData(pinData.modelRows);
        if (summaryPins?.length > this.maxPins) {
            Snackbar.showWarningSnackbar("Only the first " + this.maxPins + " orders will be plotted on this map.");
            summaryPins = summaryPins.slice(0, this.maxPins);
        }
        this.mapAvailOrders.removeAllPins();
        for (const pin of summaryPins) {
            this.createToolTipsForStops(pin);
            this.mapAvailOrders.addPin(pin);                        
            this.mapAvailOrders.pinNeedsClickListener(pin);
        }
        this.mapAvailOrders.fitPins();
    }

    private summarizePinData(allPinData: ModelRow<any>[]): MapPin[] {
        const pinDataByLocation = {};
        for (const pinData of allPinData) {
            const latitude = pinData.get(this.mapAvailOrders.latitudeField);
            const longitude = Math.abs(pinData.get(this.mapAvailOrders.longitudeField)) * -1;
            const key = latitude + "," + longitude;
            let pin = pinDataByLocation[key];
            if (pin == null) {
                pin = new MapPin(latitude, longitude);
                pin.data = pinData;
                pinDataByLocation[key] = pin;
            } 
            pin.rows.push(pinData);
        }
        const result = Object.values(pinDataByLocation) as MapPin[];
        for (const pin of result) {
            this.addMapPinFormatting(pin);
            this.createToolTipsForStops(pin);
        }
        return Object.values(pinDataByLocation);
    }

    private createToolTipsForStops(pin: MapPin) {
        if (pin.rows.length === 1) {
            const stopType = pin.data?.get("order_id") + " - " + pin.data?.get("stop_type_value") + " - ";
            const stopStatus = "Status: " + pin.data?.get("stop_status_info") + "\n";
            const stopLocationInfo = "Stop Name: " + pin.data?.get("stop_location") + "\n";
            const stopDateInfo = "Date/Time: " + pin.data?.get("stop_date_info");
            pin.tooltip = `${stopType}${stopStatus}${stopLocationInfo}${stopDateInfo}`;  
        }
        else if (pin.rows.length > 1) {
            const rowData: String[] = [];
            pin.rows.forEach((pinRow, index) => {
                const data = index+1 +". " +pinRow.get("order_id") + " - " +pinRow.get("stop_type_value") + " - " + pinRow.get("stop_status_info") + " - " 
                + pinRow.get("stop_location") + " " + pinRow.get("stop_date_info") + "\n"
                rowData.push(data);
            });             
            pin.tooltip = pin.rows.length + " orders at this exact location: \n" + rowData.join("");
        }
    }

    private addMapPinFormatting(pin: MapPin) {
        if (pin.rows.length > 1) {
            pin.image = "map-pin-cluster";
            pin.caption = ""+ pin.rows.length;
            pin.captionColor = "default";
            return;
        }
        const dataType = pin.data.get("data_type");
        if (dataType === "stop") {
            pin.caption = "" + pin.data.get("movement_sequence");
            if (pin.data?.get("status") === DELIVERED_STATUS_CODE) {
                pin.image = "map-pin-filled";
                pin.captionColor = getThemeColor("default");
                this.createToolTipsForStops(pin);
            }
            else {
                pin.image = "map-pin-outlined";
                pin.captionColor = getThemeColor("default");
                this.createToolTipsForStops(pin);
            }
        }

    }
}
